<template>
  <div id="app">
    <Home :isM="isM" :isQa="isQa" />
  </div>
</template>

<script>
import Home from './components/Home.vue'
import isMobile from './utils/isMobile'
import rem from './utils/rem'
export default {
  name: 'App',
  components: {
    Home
  },
  data() {
    const isQa = /^(test|qa)-/.test(location.hostname)
    return {
      isM: false,
      isQa: isQa,
    }
  },
  created() {
    this.isM = isMobile()
    window.addEventListener('resize', this.setRem);
    this.setRem();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setRem);
  },
  methods: {
    setRem() {
      if (this.isM) {
        rem(750)
      } else {
        rem(1920)
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  box-sizing: border-box;
  /* font-family: 'HanSansNormal'; */
  cursor: default;
}

a {
  text-decoration: none;
  cursor: pointer;
}

input:focus {
  /* 清除边框高亮效果 */
  outline: none;
  /* 可以根据需要自定义边框样式，这里将边框设为无 */
  border: none;
  /* 可以根据需要自定义背景颜色，这里保持不变 */
  background-color: inherit;
  /* 清除可能存在的阴影效果 */
  box-shadow: none;
}
</style>
